import React, { useState } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import './WhyChoose.scss'
import HTMLReactParser from "html-react-parser";


const WhyChoose = (props) => {
  const whyChoose = props.data;

  return (
    <div className="why-choose-wrapper">
      {Array.isArray(whyChoose) &&
        whyChoose.map((item, index) => (
          <div key={index} className="why-choose">
            {item.Title && <h2 className='why-choose-title'>{item.Title}</h2>}

            {item.Content && (
                <p className='why-choose-content'>{HTMLReactParser(item.Content)}</p>
            )}
          </div>
        ))}
    </div>
  );
};
export default WhyChoose;


